import { render, staticRenderFns } from "./Infoexercise.vue?vue&type=template&id=4fe1150f&"
import script from "./Infoexercise.vue?vue&type=script&lang=js&"
export * from "./Infoexercise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports